/*
----------------------------
Module - faq
----------------------------
*/

import $ from 'jquery';
/*global fmg*/

(function(){
    'use strict';
    
    fmg.faqItems = function () {

        function setupQuestionButtons() {

            var $question_btn = $(".faq__question-btn");
            $question_btn.each(function() {
                $(this).children('i').eq(1).addClass("hidden");
            })

            $question_btn.on("click", function(e){

                var $this = $(this);

                var question_id = $this.data("question");
                console.log("questionId: " + question_id)

                if($this.hasClass("answerShown")) {
                    $this.removeClass("answerShown");
                    $this.children('i').eq(0).removeClass("hidden");
                    $this.children('i').eq(1).addClass("hidden");

                } else {
                    $this.addClass("answerShown");
                    $this.children('i').eq(0).addClass("hidden");
                    $this.children('i').eq(1).removeClass("hidden");
                }
                
                // Pass in the parent folder id
                toggleAnswers(question_id, e.detail);

            });

        }

        function toggleAnswers(id) {

            var $selected_answer = $answers.filter("[data-question='"+id+"']");
            
            if($selected_answer.hasClass("fadeInDown")) {
                $selected_answer.removeClass("fadeInDown").addClass("fadeOutUp");
            }
            else {
                $selected_answer.removeClass("fadeOutUp").addClass("fadeInDown");
            }
        }

        function init() {

            if($faq.length) {
                setupQuestionButtons();
            }
        }

        var $faq = $(".faq");
        var $answers = $(".faq__answer");
        $answers.removeClass("fadeInDown").addClass("fadeOutUp");
        
        return {
            init: init
        };

    }();

    document.addEventListener("DOMContentLoaded", function () {
        fmg.faqItems.init();
    });
    
}());
